
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"238","height":"337","viewBox":"0 0 238 337","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D2232A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35.74 66.404l16.407 21.18-16.406 21.251-16.764-21.25z"}}),_c('text',{attrs:{"font-family":"RobotoCondensed-Bold, Roboto Condensed","font-size":"59","font-weight":"bold","letter-spacing":"-9.3","transform":"translate(9 2.404)"}},[_c('tspan',{attrs:{"x":".454","y":"55"}},[_v('10')])]),_c('path',{attrs:{"d":"M202.264 270.404l-16.407-21.18 16.407-21.25 16.763 21.25z"}}),_c('text',{attrs:{"font-family":"RobotoCondensed-Bold, Roboto Condensed","font-size":"59","font-weight":"bold","letter-spacing":"-9.3","transform":"rotate(180 114.502 167.202)"}},[_c('tspan',{attrs:{"x":".454","y":"55"}},[_v('10')])]),_c('g',[_c('path',{attrs:{"d":"M90.256 278.404L79.35 264.428l10.906-14.024 11.144 14.024zM148.506 278.404L137.6 264.428l10.906-14.024 11.144 14.024zM90.256 213.938L79.35 199.96l10.906-14.023L101.4 199.96zM148.506 213.938L137.6 199.96l10.906-14.023 11.144 14.023zM148.744 58.404l10.906 13.977-10.906 14.023L137.6 72.381zM90.494 58.404L101.4 72.381 90.494 86.404 79.35 72.381z"}}),_c('g',[_c('path',{attrs:{"d":"M148.744 122.871l10.906 13.977-10.906 14.023-11.144-14.023zM90.494 122.871l10.906 13.977-10.906 14.023-11.144-14.023z"}})]),_c('g',[_c('path',{attrs:{"d":"M119.381 241.804l-10.906-13.976 10.906-14.024 11.144 14.024z"}})]),_c('g',[_c('path',{attrs:{"d":"M119.619 90.604l10.906 13.977-10.906 14.023-11.144-14.023z"}})])])])])
          )
        }
      }
    